export const searchMixins = {
  methods: {
    /**
     * Searching through a field's options and returns matching results
     * @param options   An object of possible suggestions with properties 'opts' and 'searchable'
     * @param query     The query to search with
     */
    handleSearch (options, query, field) {
      if (!options) return []
      if (!(options.searchable && options.opts)) return []
      let ret1 = options.searchable.reduce((a, e, i) => e.split(' ')[field.label === 'Account' ? e.split(' ').length - 1 : 0].includes(query.toLowerCase().replace(/-/g, '')) ? a.concat(i) : a, [])
      let ret2 = options.searchable.reduce((a, e, i) => e.split(' ')[field.label === 'Account' ? e.split(' ').length - 1 : 0].includes(query) ? a.concat(i) : a, [])
      let ret3 = options.searchable.reduce((a, e, i) => e.substring(e.indexOf(' ') + 1).includes(query.toLowerCase()) ? a.concat(i) : a, [])
      return [...ret1, ...ret2, ...ret3].filter((item, i, ar) => ar.indexOf(item) === i).map(v => options.opts[v])
    },
    /**
     * Handles searching for non-remote autocomplete fields
     * @param query
     * @param cb
     * @param ref
     * @param field
     */
    async autocompleteLocalSearch ({ query, ref, field }, cb) {
      const getResults = () => this.handleSearch(field.options(), query, field)
      try {
        await new Promise((resolve, reject) => {
          this.searchTimeout = setTimeout(async () => {
            let results = query ? getResults() : field.options().opts
            if (!results.length && field.actionPayload && !field.actionPayload.noApi) {   // If no results, check the API
              let updatedQuery = { active: 'True', search: query, page_size: 200 }
              if (field.actionPayload.hasOwnProperty('query') && typeof field.actionPayload.query === 'object') {
                updatedQuery = { ...updatedQuery, ...field.actionPayload.query } // if actionPayload has a predefined query
              }
              const payload = { ...field.actionPayload, 'query': updatedQuery }
              const apiResp = await this.$store.dispatch('fetchWithQuery', payload)
              if (apiResp && apiResp.count) {
                results = getResults()
              }
            }
            cb(results)
            resolve()
          })
        })
        if (typeof this.highlightFirstAutocompleteResult === 'function') {
          this.highlightFirstAutocompleteResult(ref)
        }
      } catch (e) {
        console.log(e)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/Mixins/SearchMixins.js